import { render, staticRenderFns } from "./addResidentsHelp.vue?vue&type=template&id=8f4b6486"
import script from "./addResidentsHelp.vue?vue&type=script&lang=js"
export * from "./addResidentsHelp.vue?vue&type=script&lang=js"
import style0 from "./addResidentsHelp.vue?vue&type=style&index=0&id=8f4b6486&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports